import { ToastController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppFacade } from './../../facade/app.facade';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPage {

  credentials: { username: string, password: string};
  loginForm: FormGroup

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public facade: AppFacade,
    public fb: FormBuilder,
    public toastCtrl: ToastController,
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])],
    })
  }

  login() {
    let toast = this.toastCtrl.create({duration: 3000})
    this.facade.login(this.loginForm.value).subscribe(res => {
        toast.setMessage('Je bent nu ingelogd').present()
    }, (fail) => {
        toast.setMessage('Inloggen mislukt').present()
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts